// src/hooks/useMobile.js
import { useState, useEffect } from 'react';

export function useMobile(breakpoint = 768) {
  // Lazy initializer: () => ... runs only when the component first renders,
  // NOT at module import time — this fixes the "invalid hook call" error.
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth <= breakpoint
  );

  useEffect(() => {
    const fn = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, [breakpoint]);

  return isMobile;
}